import React from "react";
import HeaderSection from "../../components/header";
import CommonHeroSection from "../../components/CommonHeroSection/CommonHeroSection";
import Footer from "../../components/footerSection";
import image2 from "../../assets/woodbgimg.png";
import ContactUsSection from "../../components/servicesSection/ContactUsSection";
import GallarySection from "./GallarySection";
import gImg from "../../assets/woodfireplaceimg.png";
import gImg1 from "../../assets/woodstoveimg.png";
import WhyChooseSection from "./WhyChooseSection";

export default function ServicePageWood() {
  let gallaryData = [
    {
      gallaryImg: gImg,
      headText: `Wood Burning`,
      highlightText: `Fireplace`,
      extraText: `These are typically built into 
            homes with masonry or metal constructions. These
            fireplaces feature an open hearth where logs can be 
            burned directly, radiating heat and creating a cozy 
            atmosphere.`,
      gallaryImg1: gImg1,
      headText1: `Wood Burning`,
      highlightText1: `Stoves`,
      extraText1: `They are free-standing units that 
            are made from cast iron or steel, these stoves feature 
            a closed combustion chamber with a glass door, 
            allowing for controlled burning and better heat retention. 
            It comes in various sizes and styles, from traditional to 
            contemporary. It can be a more environmentally friendly 
            option compared to open fireplaces since they burn
            wood more efficiently.`,
    },
  ];

  let titlesBox = [
    "Aromatic Ambience",
    "Traditional Flame",
    "Natural Resource Utilization",
    "Dependable source of heat",
  ];

  console.log(gallaryData);
  return (
    <div>
      <HeaderSection />
      <CommonHeroSection
        imgName={image2}
        titleHead="Wood"
        extraContent={`Home > Our Services >Wood`}
      />

      <GallarySection
        gallaryImg={gallaryData[0]?.gallaryImg}
        extraContent={gallaryData[0]?.extraText}
        secSent={gallaryData[0]?.highlightText}
        firstSent={gallaryData[0]?.headText}
        gallaryImg1={gallaryData[0]?.gallaryImg1}
        extraContent1={gallaryData[0]?.extraText1}
        secSent1={gallaryData[0]?.highlightText1}
        firstSent1={gallaryData[0]?.headText1}
      />

      <WhyChooseSection
        firstSent={"Why Choose"}
        secSent={"Wood Flame?"}
        titlesBox={titlesBox}
      />

      <ContactUsSection />

      <Footer />
    </div>
  );
}
